export const BANNER_DATA_IDS = {
  base: 'banner',
  container: '',
  primaryAction: 'primaryAction',
  secondaryAction: 'secondaryAction',
  close: 'close'
};
